module.exports = __webpack_public_path__ + "static/img/product_1_5.09dc7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_5.png
// module id = 0Zun
// module chunks = 34